export default __webpack_public_path__ + "static/media/mast_icon.514d5388.svg";